import cfg from 'client/common/utils/client-config';

export function genLoginLink(): string {
    const retpath = window.location.href;

    return `${cfg.passport.front.host}/auth?retpath=${encodeURIComponent(retpath)}`;
}
